"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../../utils/index.js");
var INCA_CLK = 'inca_clk';
var INCA_IMP = 'inca_imp';
var OFFER_CLK = 'offer_clk';
var OFFER_IMP = 'offer_imp';
var getCampaign = function getCampaign(_ref) {
  var excludeCampaignCounter = _ref.excludeCampaignCounter,
    internalCampaignName = _ref.internalCampaignName,
    isCrossSell = _ref.isCrossSell,
    isIncaClicks = _ref.isIncaClicks,
    isIncaImpressions = _ref.isIncaImpressions,
    isOfferClicks = _ref.isOfferClicks,
    isOfferImpressions = _ref.isOfferImpressions,
    negativeFeedback = _ref.negativeFeedback,
    ngcOrderItemID = _ref.ngcOrderItemID,
    offerCode = _ref.offerCode,
    offerHeadline = _ref.offerHeadline,
    offerName = _ref.offerName,
    offerOrderType = _ref.offerOrderType,
    offerRanking = _ref.offerRanking,
    positiveFeedback = _ref.positiveFeedback,
    productLine = _ref.productLine,
    promoCode = _ref.promoCode,
    subscriberPhoneNumber = _ref.subscriberPhoneNumber;
  var common = {
    _telus: {
      positiveFeedback: positiveFeedback,
      negativeFeedback: negativeFeedback,
      isCrossSell: isCrossSell,
      internalCampaignName: internalCampaignName,
      offerCode: offerCode,
      promoCode: promoCode,
      offerHeadline: offerHeadline,
      offerName: offerName,
      offerOrderType: offerOrderType,
      offerRanking: offerRanking,
      productLine: productLine,
      ngcOrderItemID: ngcOrderItemID,
      subscriberPhoneNumber: subscriberPhoneNumber
    }
  };
  var campaign = {};
  if (isIncaClicks) {
    campaign = {
      SKU: INCA_CLK,
      name: INCA_CLK,
      _telus: {
        campaignClick: excludeCampaignCounter ? undefined : 1
      }
    };
  }
  if (isIncaImpressions) {
    campaign = {
      SKU: INCA_IMP,
      name: INCA_IMP,
      _telus: {
        campaignImpression: excludeCampaignCounter ? undefined : 1
      }
    };
  }
  if (isOfferClicks) {
    campaign = {
      SKU: OFFER_CLK,
      name: OFFER_CLK,
      _telus: {
        offerClicks: excludeCampaignCounter ? undefined : 1
      }
    };
  }
  if (isOfferImpressions) {
    campaign = {
      SKU: OFFER_IMP,
      name: OFFER_IMP,
      _telus: {
        offerImpressions: excludeCampaignCounter ? undefined : 1
      }
    };
  }
  return (0, _index.mergeObjects)(common, campaign);
};
var _default = exports["default"] = getCampaign;